import { apiPost } from '../../api'

export const save_document = data => {
  return apiPost({
    endpoint: 'documents/save_document',
    data: data
  })
}
